
import YotpoPreview from "./yotpoPreview";
import YotpoPreviewList from "./yotpoPreviewList";


/**
 * entry point
 */
document.addEventListener('DOMContentLoaded', () => {

    const $yotpo = document.getElementById('yotpo-reviews');
    if($yotpo) {
        YotpoPreview.Init();
    }

    const $yotpoList = document.querySelectorAll('[yotpo-block]') ;
    $yotpoList.forEach($yotpoBlock  => {
        //if(cnt++ > 0)
        //    return;
        if(!$yotpoBlock || !$yotpoBlock.textContent)
            return;


        const yotpoMainWidget:any = $yotpoBlock.getElementsByClassName('yotpo-main-widget');
        if(!yotpoMainWidget || !yotpoMainWidget[0])
            return;

        const yotpoApiKey = document.getElementById('yotpo-api-key')?.textContent;
        const previewImageDiv:any = $yotpoBlock.querySelectorAll('[yotpo-previewimage]');

        let  previewImage = null;
        let  productTitle = null;
        if(previewImageDiv && previewImageDiv[0] && previewImageDiv[0].children && previewImageDiv[0].children[0]) {
            previewImage = previewImageDiv[0].children[0].src;
            if(previewImage && previewImage !== '')
                previewImage = previewImage.split('?')[0];
            productTitle = previewImageDiv[0].children[0].getAttribute("data-yotpo-title");
        }

        const skunumberDiv:any = $yotpoBlock.querySelectorAll('[yotpo-skunumber]');
        let  skunumber = null;
        if(skunumberDiv && skunumberDiv[0] && skunumberDiv[0].textContent)
            skunumber = skunumberDiv[0].textContent;

        //console.log(`previewImage:${previewImage}, skunumber:${skunumber}`);
        YotpoPreviewList.Init(yotpoMainWidget[0], yotpoApiKey, skunumber, previewImage,productTitle);
    });

});

